<template>
  <Doughnut 
    :chart-options="chartOptions"
    :chart-data="computedData"
    
  />
</template>

<script>
import { Doughnut } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

export default {
  components: {
    Doughnut
  },
  props: {
    chartData:{
    required:true
    }
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: true,
        borderWidth: 1,
        cutout: '80%',
        borderRadius: 5,
        offset: 10
      },
    }
  },
  
  computed:{
    computedData(){
      let data=this.chartData
      delete data.total 
      return {
        //labels:Object.keys(data),
        labels:['Setup My Agency','Setup My Clients'],
        datasets:[{
           backgroundColor: ['#FF7479', '#646CDF'],
          data:Object.values(data)
        }
        
        ]
      }
    }
  },
  mounted(){

  }
}
</script>
